<template>
  <div class="member-benefit-wrap">
    <div class="common-seach-wrap">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="openEdit()">新增权益</el-button>
    </div>

    <div class="table-wrap">
      <el-table size="small" :data="list">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="name" label="权益名称" width="120" />
        <el-table-column prop="level" label="等级" width="80" />
        <el-table-column label="权益价格" width="120">
          <template slot-scope="scope">¥{{ Number(scope.row.member_price || 0).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="可接对单业务类型" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ getBizTypeLabels(scope.row.biz_type_codes) }}</template>
        </el-table-column>
        <el-table-column prop="daily_contact_limit" label="每日接对单次数" width="120">
          <template slot-scope="scope">{{ scope.row.daily_contact_limit === 0 ? '不限制' : scope.row.daily_contact_limit }}</template>
        </el-table-column>
        <el-table-column prop="priority_after_minutes" label="可接对单起始(分钟)" width="140" />
        <el-table-column prop="rank_sort" label="发单排序权重" width="100" />
        <el-table-column prop="list_rank_hours" label="列表优先小时数" width="120" />
        <el-table-column label="每月权益" min-width="220" show-overflow-tooltip>
          <template slot-scope="scope">{{ getMonthlyBenefitSummary(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="sort" label="展示排序" width="90" />
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              @click="changeStatus(scope.row, scope.row.status === 1 ? 0 : 1)"
            >
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="searchObj.page"
        :page-size="searchObj.list_rows"
        layout="total, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id ? '编辑权益' : '新增权益'" :visible.sync="visible" width="640px">
      <el-form :model="form" label-width="140px" size="small">
        <el-form-item label="权益名称">
          <el-input v-model="form.name" placeholder="如：白银/黄金/钻石/红金" />
        </el-form-item>
        <el-form-item label="等级数值">
          <el-input-number
            v-model="form.level"
            :min="1"
            :max="99"
            :disabled="!!form.id"
            placeholder="越大等级越高"
          />
          <span v-if="form.id" class="form-tip">等级ID创建后不可修改</span>
        </el-form-item>
        
        <el-form-item label="可接对单业务类型">
          <el-select
            v-model="form.biz_type_codes_array"
            multiple
            placeholder="请选择可接对单的业务类型"
            style="width: 100%"
          >
            <el-option
              v-for="item in bizTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="每日接对单次数">
          <el-input-number v-model="form.daily_contact_limit" :min="0" :max="999" />
          <span class="form-tip">0 表示不限制</span>
        </el-form-item>
        <el-form-item label="可接对单起始(分钟)">
          <el-input-number v-model="form.priority_after_minutes" :min="0" :max="999" />
          <span class="form-tip">发单后多少分钟该等级可接对单</span>
        </el-form-item>
        <el-form-item label="发单排序权重">
          <el-input-number v-model="form.rank_sort" :min="1" :max="99" />
          <span class="form-tip">数字越小列表越靠前（红金1 钻石2 黄金3 白银4）</span>
        </el-form-item>
        <el-form-item label="列表优先小时数">
          <el-input-number v-model="form.list_rank_hours" :min="0" :max="24" />
          <span class="form-tip">发对单列表按等级排序的小时数</span>
        </el-form-item>
        <el-divider content-position="left">每月权益（仅配置与展示）</el-divider>
        <el-form-item label="每月同城接单次数">
          <el-input-number v-model="form.monthly_same_city_contact_count" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="每月门店推广次数">
          <el-input-number v-model="form.monthly_store_promotion_count" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="每月发单置顶次数">
          <el-input-number v-model="form.monthly_order_top_count" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="每月官方广告位次数">
          <el-input-number v-model="form.monthly_official_ad_count" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="每月公开课次数">
          <el-input-number v-model="form.monthly_public_course_count" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="每月快速审核次数">
          <el-input-number v-model="form.monthly_fast_audit_count" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="每月发单制定次数">
          <el-input-number v-model="form.monthly_order_custom_count" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="权益价格(元)">
          <el-input-number v-model="form.member_price" :min="0" :max="9999999" :precision="2" :step="1" />
          <span class="form-tip">仅展示使用，不参与业务计算</span>
        </el-form-item>
        <el-form-item label="权益描述">
          <el-input v-model="form.description" type="textarea" :rows="3" placeholder="展示用" />
        </el-form-item>
        <el-form-item label="展示排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitSave">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import {
  MAIN_KEY,
  fetchLabelValueOptions,
  FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST,
  bizTypeTextFromOptions,
} from '@/utils/sysEnumOptions'

export default {
  name: 'MemberBenefitSetting',
  data () {
    return {
      searchObj: {
        page: 1,
        list_rows: 15
      },
      list: [],
      total: 0,
      visible: false,
      loading: false,
      form: {
        id: 0,
        name: '',
        level: 1,
        member_price: 0,
        biz_type_codes: '',
        biz_type_codes_array: [],
        daily_contact_limit: 0,
        priority_after_minutes: 30,
        rank_sort: 99,
        list_rank_hours: 2,
        monthly_same_city_contact_count: 0,
        monthly_store_promotion_count: 0,
        monthly_order_top_count: 0,
        monthly_official_ad_count: 0,
        monthly_public_course_count: 0,
        monthly_fast_audit_count: 0,
        monthly_order_custom_count: 0,
        description: '',
        sort: 0,
        status: 1
      },
      monthlyBenefitLabels: [
        { key: 'monthly_same_city_contact_count', label: '同城接单' },
        { key: 'monthly_store_promotion_count', label: '门店推广' },
        { key: 'monthly_order_top_count', label: '发单置顶' },
        { key: 'monthly_official_ad_count', label: '官方广告位' },
        { key: 'monthly_public_course_count', label: '公开课' },
        { key: 'monthly_fast_audit_count', label: '快速审核' },
        { key: 'monthly_order_custom_count', label: '发单制定' }
      ],
      bizTypeOptions: [...FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST],
    }
  },
  created () {
    fetchLabelValueOptions(MAIN_KEY.issueOrderBizType, { stringValue: true }, FALLBACK_ISSUE_ORDER_BIZ_TYPE_LIST)
      .then(list => { this.bizTypeOptions = list })
      .catch(() => {})
    this.loadList()
  },
  methods: {
    loadList () {
      request._post('/shop/memberbenefit.Memberbenefit/index', this.searchObj, true).then(res => {
        if (res.data && res.data.list) {
          const list = res.data.list
          this.list = list.data || list
          this.total = list.total != null ? list.total : (this.list.length || 0)
        }
      }).catch(() => {})
    },
    pageChange (page) {
      this.searchObj.page = page
      this.loadList()
    },
    getMonthlyBenefitSummary (row) {
      return this.monthlyBenefitLabels
        .map(item => item.label + (row[item.key] != null ? row[item.key] : 0))
        .join('、')
    },
    getBizTypeLabels (bizTypeCodes) {
      if (!bizTypeCodes) return ''
      const codes = String(bizTypeCodes).split(',').map(s => s.trim()).filter(Boolean)
      return codes.map(c => bizTypeTextFromOptions(c, this.bizTypeOptions) || c).join('、')
    },
    openEdit (row) {
      if (row && row.id) {
        request._get('/shop/memberbenefit.Memberbenefit/edit', { id: row.id }, true).then(res => {
          if (res.data && res.data.model) {
            const m = res.data.model
            this.form = { ...this.form, ...m }
            this.form.biz_type_codes_array = (m.biz_type_codes || '').split(',').map(s => s.trim()).filter(Boolean)
          }
          this.visible = true
        }).catch(() => {})
      } else {
        this.form = {
          id: 0,
          name: '',
          level: 1,
          member_price: 0,
          biz_type_codes: '',
          biz_type_codes_array: (this.bizTypeOptions || []).map(o => o.value),
          daily_contact_limit: 0,
          priority_after_minutes: 30,
          rank_sort: 99,
          list_rank_hours: 2,
          monthly_same_city_contact_count: 0,
          monthly_store_promotion_count: 0,
          monthly_order_top_count: 0,
          monthly_official_ad_count: 0,
          monthly_public_course_count: 0,
          monthly_fast_audit_count: 0,
          monthly_order_custom_count: 0,
          description: '',
          sort: 0,
          status: 1
        }
        this.visible = true
      }
    },
    submitSave () {
      const currentLevel = Number(this.form.level || 0)
      if (currentLevel < 1) {
        this.$message.warning('等级数值必须大于0')
        return
      }
      // 前端限制：等级值不能重复（编辑场景排除当前记录）
      const duplicated = (this.list || []).some(item =>
        Number(item.level) === currentLevel && Number(item.id) !== Number(this.form.id || 0)
      )
      if (duplicated) {
        this.$message.warning('等级数值已存在，请勿重复')
        return
      }

      const api = this.form.id ? '/shop/memberbenefit.Memberbenefit/edit' : '/shop/memberbenefit.Memberbenefit/add'
      const postData = { ...this.form }
      postData.biz_type_codes = Array.isArray(this.form.biz_type_codes_array)
        ? this.form.biz_type_codes_array.join(',')
        : (this.form.biz_type_codes || '')
      delete postData.biz_type_codes_array
      this.loading = true
      request._post(api, postData, true).then(res => {
        this.loading = false
        if (res.code === 1) {
          this.$message.success(res.msg || '保存成功')
          this.visible = false
          this.loadList()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }).catch(() => { this.loading = false })
    },
    changeStatus (row, status) {
      const action = status === 1 ? '启用' : '禁用'
      this.$confirm('确定' + action + '该权益？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request._post('/shop/memberbenefit.Memberbenefit/changeStatus', { id: row.id, status }, true).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg || action + '成功')
            this.loadList()
          } else {
            this.$message.error(res.msg || action + '失败')
          }
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.member-benefit-wrap { padding: 10px; }
.form-tip { margin-left: 8px; color: #999; font-size: 12px; }
.pagination { margin-top: 12px; }
</style>



// WEBPACK FOOTER //
// src/views/setting/memberbenefit/index.vue